document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('#MobileMenu');
  if (menuButton && mobileMenu) {
    menuButton.addEventListener('click', () => {
      const open = menuButton.getAttribute('aria-expanded') === 'true';
      menuButton.setAttribute('aria-expanded', String(!open));
      mobileMenu.hidden = open;
    });
  }

  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const variantData = section.querySelector('[data-product-json]');
    const idInput = section.querySelector('[data-variant-id]');
    const addButton = section.querySelector('[data-add-button]');
    const price = section.querySelector('[data-product-price]');
    const optionGroups = [...section.querySelectorAll('[data-option-group]')];
    if (!variantData || !idInput || !addButton) return;

    const variants = JSON.parse(variantData.textContent || '[]');
    const updateVariant = () => {
      const chosen = optionGroups.map((group) => group.querySelector('[data-option-input]:checked')?.value);
      const variant = variants.find((item) => item.options.every((option, index) => option === chosen[index]));
      if (!variant) {
        addButton.disabled = true;
        addButton.textContent = 'Unavailable';
        return;
      }
      idInput.value = variant.id;
      addButton.disabled = !variant.available;
      addButton.textContent = variant.available ? 'Add to bag' : 'Sold out';
      if (price) price.textContent = new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format(variant.price / 100);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };
    section.querySelectorAll('[data-option-input]').forEach((input) => input.addEventListener('change', updateVariant));

    const mainImage = section.querySelector('.product-main-image');
    const thumbnails = [...section.querySelectorAll('[data-product-thumbnail]')];
    thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => {
        if (!mainImage) return;
        mainImage.src = thumbnail.dataset.imageSrc;
        mainImage.removeAttribute('srcset');
        thumbnails.forEach((item) => item.classList.remove('is-active'));
        thumbnail.classList.add('is-active');
      });
    });
  });
});
